import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import App from './components/App';
import { ConfigProvider } from 'antd'
import faIR from 'antd/es/locale/fa_IR';
import { getAntdTheme } from './theme/antdTheme';
import './assets/main.scss';
import { initSentry } from "./utils/sentryInit";
import { ThemeProvider, useTheme } from './hooks/useTheme';

initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));

const ThemedApp = () => {
  const { theme } = useTheme();

  return (
    <ConfigProvider theme={getAntdTheme(theme)} locale={faIR} direction="rtl">
      <App />
    </ConfigProvider>
  );
};

root.render(
  <BrowserRouter>
    <HelmetProvider>
      <ThemeProvider>
        <ThemedApp />
      </ThemeProvider>
    </HelmetProvider>
  </BrowserRouter>
);
